import axios from 'axios'
import { encodeBase64, getBrowserDetail } from 'utils/helpers'
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_API,
  timeout: 500000
})
axiosInstance.interceptors.request.use(
  async (config) => {
    // config.headers.Authorization = `Bearer ${process.env.REACT_APP_TWITTER_BEARER_TOKEN}`
    // config.headers.withCredentials = true
    // config.headers['Content-Type'] = "application/x-www-form-urlencoded"
    return config
  },
  (error) => {
    console.log('axios.interceptors error')
    return error
  }
)

export const doTwitterLinkingLogin = async (refSrc, twitterRole, ssoAccessToken) => {
  try {
    let redicatData = { riddle: refSrc, twitter_role: twitterRole }
    redicatData = encodeBase64(JSON.stringify(redicatData))
    const rediractUrl = `${process.env.REACT_APP_TWITTER_REDIRACT_URI}?rediract_data=${redicatData}`
    const data = {
      scope: ['tweet.read', 'users.read','tweet.write','like.write'],
      redirect_uri: rediractUrl
    }

    const twitterAccessUrl = `/twitterLogin`
    const responce = await axiosInstance.post(twitterAccessUrl, data, {
      headers: {
        Authorization: `Bearer ${ssoAccessToken}`
      }
    })
    if (responce.data.url) {
      window.open(responce.data.url, '_self')
      return true
    }
    return false
  } catch (error) {
    console.log("error:", error)
    return false
  }
}
export const getUserInfoAccessToken = async (code, src, ssoAccessToken, rediract_data) => {
  try {
    const rediractUrl = `${process.env.REACT_APP_TWITTER_REDIRACT_URI}?rediract_data=${rediract_data}`
    const twitterAccessUrl = `/twitterAccessToken`
    const responce = await axiosInstance.post(
      twitterAccessUrl,
      {
        code,
        redirect_uri: rediractUrl
      },
      {
        headers: {
          Authorization: `Bearer ${ssoAccessToken}`
        }
      }
    )
    return responce?.data ?? null
  } catch (error) {
    return null
  }
}
